import * as w6s from "szient-js-sdk";

export default defineNuxtPlugin({
  name: "szient-js-sdk-plugin",
  parallel: true,
  setup(nuxtApp) {
    const config = {
      debug: false,
      useHttp: true,
      cordovajs: {
        android: "https://open.workplus.io/static/android.cordova.min.js",
        iOS: "https://open.workplus.io/static/ios.cordova.min.js",
      },
    };
    w6s.init(config);
    nuxtApp.provide("w6s", w6s);
  },
});

declare module "nuxt/app" {
  interface NuxtApp {
    $w6s: typeof w6s;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $w6s: typeof w6s;
  }
}
